import { render, staticRenderFns } from "./HomeAdmin.vue?vue&type=template&id=99c74094&scoped=true"
import script from "./HomeAdmin.vue?vue&type=script&lang=js"
export * from "./HomeAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c74094",
  null
  
)

export default component.exports